import { render, staticRenderFns } from "./properties-text-compare.vue?vue&type=template&id=09ab2719&scoped=true"
import script from "./properties-text-compare.vue?vue&type=script&lang=js"
export * from "./properties-text-compare.vue?vue&type=script&lang=js"
import style0 from "./properties-text-compare.vue?vue&type=style&index=0&id=09ab2719&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ab2719",
  null
  
)

export default component.exports